import {
  createTopoloAuth,
  decodeJwtPayload,
  getAppId,
  getTokenExpiration,
  isTokenExpired,
  isTokenFullyExpired,
  resolveTopoloBrowserAuthBaseUrl,
} from '@topolo-io/app-shell';
import type { AppUser, AppAuthTokens, TopoloAuth } from '@topolo-io/app-shell';

// Roadmapper keeps these aliases for its existing import sites; the canonical
// user/token shapes now come from @topolo-io/app-shell.
export type AuthUser = AppUser;
export type AuthTokens = AppAuthTokens;

// Per-tab sessionStorage restore keeps normal browser refreshes signed in.
const sessionStorageRestoreEnabled =
  (import.meta as any).env?.VITE_SESSION_STORAGE_RESTORE !== 'false';

const AUTH_SERVICE_URL = resolveTopoloBrowserAuthBaseUrl();

/**
 * The single canonical Topolo auth instance, built on @topolo-io/app-shell's
 * `createTopoloAuth` (which wraps auth-client's browser session controller).
 * Drives the app-shell TopoloAuthProvider mounted by TopoloAppRoot in App.tsx.
 * The app id is resolved at runtime from the Catalog-injected global.
 */
export const authClient: TopoloAuth = createTopoloAuth({
  authServiceUrl: AUTH_SERVICE_URL,
  appId: getAppId(),
  devSessionKey: 'topolo_roadmapper_session',
  callbackPath: '/auth/callback',
  sessionStorageRestoreEnabled,
  debug: Boolean((import.meta as any).env?.DEV),
});

export const accessTokenMemory = authClient.accessTokenMemory;
export const accessTokenSession = authClient.accessTokenSession;
export const buildUserFromAccessToken = authClient.buildUserFromAccessToken;

export { decodeJwtPayload, getTokenExpiration, isTokenExpired, isTokenFullyExpired };
